<template>
  <div class="item-box">
    <!-- item -->
    <div class="item">
      <el-row class="ql-header">
        <el-col
          :span="12"
          class="title"
          v-text="item.company || '--'"
        />
        <el-col
          :span="12"
          class="ops-btn"
        >
          <template>
            <el-tooltip
              content="请进入“查看详情”，进行释放"
              placement="top"
              effect="light"
            >
              <span class="tip">想要释放产品？</span>
            </el-tooltip>&nbsp;&nbsp;&nbsp;
            <el-button
              v-if="canadvertiserDetail"
              size="medium"
              type="primary"
              @click="toDetail(item)"
            >
              查看详情
            </el-button>
          </template>
        </el-col>
      </el-row>

      <el-row class="ql-content">
        <el-col :span="11">
          <div
            v-for="bi in baseInfo"
            :key="bi.label"
            class="content-item l"
          >
            <span class="label">{{ bi.label }}：</span>
            <span
              class="value"
              v-text="bi.value"
            />
          </div>
        </el-col>
        <el-col :span="13">
          <div class="content-item r">
            <span class="label">已开户产品：</span>
            <span class="value">
              <span
                v-for="(pi, pin) in cooperationProducts"
                :key="pin"
              >
                <el-tag
                  v-if="pi.product_name === '--'"
                  class="tag"
                  type="success"
                >
                  --
                </el-tag>
                <el-tooltip
                  v-else
                  :content="`归属时间：${pi.owner_at}`"
                  placement="top"
                  effect="light"
                >
                  <el-tag
                    class="tag"
                    type="success"
                  >
                    {{ pi.product_name }}
                  </el-tag>
                </el-tooltip>
              </span>
            </span>
          </div>
          <div class="content-item r">
            <span class="label">
              <span class="un-cooperation-tt">未开户产品：</span>
              <span class="un-cooperation-tt">(含开户中)</span>
            </span>
            <span class="value">
              <span
                v-for="(pi, pin) in unCooperationProducts"
                :key="pin"
              >
                <el-tag
                  v-if="pi.product_name === '--'"
                  class="tag"
                  type="warning"
                >
                  --
                </el-tag>
                <el-tooltip
                  v-else
                  :content="`归属时间：${pi.owner_at} 离释放还有${pi.over_day}天`"
                  placement="top"
                  effect="light"
                >
                  <el-tag
                    class="tag"
                    type="warning"
                  >
                    {{
                      `${pi.product_name}（${pi.over_day}天）`
                    }}
                  </el-tag>
                </el-tooltip>
              </span>
            </span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import $util from '@/common/js/util';

export default {
  name: 'Item',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    brands: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    brandText() {
      const brandId = this.item.brand || '';
      const brands = this.brands || [];
      return (brands.find((i) => i.id === brandId) || {}).name || '暂无';
    },

    cooperationProducts() {
      return this.item.product && this.item.product.cooperation
        ? this.item.product.cooperation
        : [{ product_name: '--' }];
    },
    unCooperationProducts() {
      return this.item.product && this.item.product.un_cooperation
        ? this.item.product.un_cooperation
        : [{ product_name: '--' }];
    },
    baseInfo() {
      const { customer_id: customerId, owner_name: ownerName } = this.item;
      const result = [
        { label: '品牌', value: this.brandText },
        { label: '编号', value: customerId || '--' },
        { label: '直客销售', value: ownerName || '--' },
      ];
      return result;
    },

    perms() {
      return this.$store.state.perms;
    },

    canadvertiserDetail() {
      return this.perms.includes('advertiserManagePrivateDetail');
    },
  },
  methods: {
    // 跳转详情
    toDetail(item) {
      if (!item.customer_id) return;
      let url = '/advertiser-manage/detail';
      url += `?customerId=${item.customer_id}&type=1&owner=${item.owner}`;
      $util.openUrl(url, { newWin: true });
    },
  },
};
</script>

<style lang="less" scoped>
.item {
  position: relative;

  .ql-header {
    padding-bottom: 28px;
    .title {
      color: #303133;
      font-size: 24px;
      line-height: 36px;
      font-family: Helvetica;
    }
    .ops-btn {
      text-align: right;
    }
    .tip {
      display: inline-block;
      color: #606266;
      font-size: 14px;
    }
  }

  .content-item {
    display: flex;
    &.l {
      padding-bottom: 21px;
      &:last-child {
        padding-bottom: 0;
      }
    }
    &.r {
      padding-bottom: 14px;
      &:last-child {
        padding-bottom: 0;
      }
    }
    .label {
      flex-shrink: 0;
      padding-right: 20px;
      display: inline-block;
      width: 112px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(144, 147, 153, 1);
    }
    .value {
      font-size: 14px;
      font-weight: 500;
      color: rgba(48, 49, 51, 1);

      .tag {
        margin: 0 10px 10px 0;
      }
    }
    .un-cooperation-tt {
      display: block;
    }
  }

  .step-content {
    .step-item {
      position: relative;
    }
    .label {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      font-size: 14px;
      font-weight: 500;
      color: rgba(144, 147, 153, 1);
    }
    .value {
      position: relative;
      padding-left: 132px;
      margin-left: -4%;
    }
  }
}
</style>
